import { useState, useCallback, useEffect } from "react";
import { If } from "react-conditional-components-renderer";
import { useFormik } from "formik";
import * as Yup from "yup";
import classNames from "classnames";

import AscTextInput from "../AscInputFields/AscTextInput/AscTextInput";
import AscButton from "../AscButton/AscButton";
import AscModal from "../AscModal/AscModal";
import Empty from "../../assets/icons/empty_image.svg";
import AddImage from "../../assets/icons/add_img.svg";
import AscFilesUploader from "../AscFilesUploader/AscFilesUploader";

import styles from "./AscAddBatch.module.scss";

export interface AscAddBatchProps {
  className?: string;
  withoutAdd?: boolean;
  batchName?: string;
  image?: string;
  onSubmit: (values: any) => void;
}

export default function AscAddBatch({
  className,
  withoutAdd,
  batchName,
  image,
  onSubmit,
}: AscAddBatchProps) {
  const [updoadModal, setIsModalOpen] = useState(false);
  const [thumbnailUrl, setThumbnailUrl] = useState<any>("");

  const formik = useFormik({
    initialValues: {
      name: batchName ? batchName : "",
      batchImage: image || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required(" "),
    }),
    onSubmit: (values) => {
      onSubmit({
        ...(values.name !== batchName ? { name: values.name } : {}),
        ...(values.batchImage !== image
          ? { batchImage: values.batchImage }
          : {}),
      });
    },
  });
  useEffect(() => {
    formik.setValues({
      name: batchName || "",
      batchImage: image || "",
    });
    formik.setTouched({});
  }, [batchName, image]);

  const handleUpload = useCallback((acceptedFiles: any[]) => {
    const newUrl = URL.createObjectURL(acceptedFiles[0]);
    setThumbnailUrl(newUrl);

    formik.setFieldValue("batchImage", acceptedFiles[0]);
    formik.setFieldTouched("batchImage", true);
    setIsModalOpen(false);
  }, []);

  return (
    <form
      className={classNames(styles.container, className)}
      onSubmit={formik.handleSubmit}
    >
      <div className={styles.mainSection}>
        <img
          src={thumbnailUrl || image || Empty}
          alt="batch_image"
          className={styles.image}
        />
        <If test={!withoutAdd}>
          <div className={styles.button} onClick={() => setIsModalOpen(true)}>
            <img
              src={AddImage}
              alt="upload_batch_image"
              className={styles.imageUpload}
            />
          </div>
        </If>

        <div className={styles.form}>
          <label className={styles.fieldLabel} htmlFor="name">
            Batch
          </label>
          <AscTextInput
            className={classNames(styles.inputField, {
              [styles.errorInput]: formik.errors.name && formik.touched.name,
            })}
            fullWidth={true}
            placeholder="Year 9"
            id="name"
            name="name"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.name}
          />
          {formik.errors.name && formik.touched.name && (
            <div className={styles.fieldError}>{formik.errors.name}</div>
          )}
        </div>
      </div>
      <div className={styles.footerSave}>
        <AscButton
          type="submit"
          disabled={
            !formik.isValid ||
            !(formik.touched.name || formik.touched.batchImage)
          }
        >
          {batchName ? "Save changes" : "Save"}
        </AscButton>
      </div>
      {updoadModal && (
        <AscModal
          visible={updoadModal}
          onClose={() => setIsModalOpen(false)}
          innerContentClassName={styles.modalContent}
        >
          <AscFilesUploader
            name="batchImage"
            type="image"
            accept={{
              "image/*": [".jpeg", ".png"],
            }}
            multiple={false}
            onDrop={handleUpload}
            srcFile=""
            className={styles.image}
          />
        </AscModal>
      )}
    </form>
  );
}
